<template>
<div class="chapter">
<div class="inner_page">
<p class="cta" id="d7e93211"><a class="calibre4" href="#/Text/Meye_9781621369127_epub_c3_r1#d6e2" id="d7e2"><span class="ash1" id="d14e273">PARTE I</span></a></p>
<p class="h1a" id="d7e93711"><a class="calibre4" href="#/Text/Meye_9781621369127_epub_c3_r1#d6e2" id="d14e276">Los<br class="calibre5"/>
  complementos<br class="calibre5"/>
  de la pasión<br class="calibre5"/>
  y el propósito</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Meye_9781621369127_epub_c5_r1.vue?51b46768